
<div class="progress-note-inner" >
    <div *ngIf="saveFailed" class="alert alert-danger" role="alert">
      Your progress note could not be saved on this device. Keep Spark open and retry saving.
      <button type="button" class="btn btn-outline-danger ms-2" [disabled]="isSaving" (click)="saveProgressNote()">Retry saving</button>
    </div>
    <div class="progress-note-section" *ngIf="progressNoteStep == 1">
      <h4 class="w-100 text-center">Select all present at session</h4>
      <div class="progress-note-section-content">
        <div class="progress-note-section-content-item">
          <p-checkbox
            type="checkbox"
            id="select-all-present-at-session"
            class="progress-note-section-content-item-checkbox"
            name="presentAtSession"
            value="Parent/Guardian"
            [(ngModel)]="presentAtSession"
            (ngModelChange)="changeData($event)"
            [disabled]="isPreview"
          ></p-checkbox>
          <label
            for="select-all-present-at-session"
            class="ms-2 progress-note-section-content-item-label"
            >Parent/Guardian</label
          >
        </div>
        <div class="progress-note-section-content-item">
          <p-checkbox
            type="checkbox"
            id="select-all-present-at-session"
            class="progress-note-section-content-item-checkbox"
            name="presentAtSession"
            value="BCBA"
            [(ngModel)]="presentAtSession"
            (ngModelChange)="changeData($event)"
            [disabled]="isPreview"
          ></p-checkbox>
          <label
            for="select-all-present-at-session"
            class="ms-2 progress-note-section-content-item-label"
            >BCBA</label
          >
        </div>
        <div class="progress-note-section-content-item">
          <p-checkbox
            type="checkbox"
            id="select-all-present-at-session"
            class="progress-note-section-content-item-checkbox"
            name="presentAtSession"
            value="Siblings"
            [(ngModel)]="presentAtSession"
            (ngModelChange)="changeData($event)"
            [disabled]="isPreview"
          ></p-checkbox>
          <label
            for="select-all-present-at-session"
            class="ms-2 progress-note-section-content-item-label"
            >Siblings</label
          >
        </div>
        <div class="progress-note-section-content-item">
          <p-checkbox
            type="checkbox"
            id="select-all-present-at-session"
            class="progress-note-section-content-item-checkbox"
            name="presentAtSession"
            value="Peer"
            [(ngModel)]="presentAtSession"
            (ngModelChange)="changeData($event)"
            [disabled]="isPreview"
          ></p-checkbox>
          <label
            for="select-all-present-at-session"
            class="ms-2 progress-note-section-content-item-label"
            >Peer</label
          >
        </div>
        <div class="progress-note-section-content-item">
          
          <label
            for="others-present-at-session"
            class="me-2 progress-note-section-content-item-label"
            >Others</label
          >
          <input type="text" id="others-present-at-session" class="form-control" [(ngModel)]="othersPresentAtSession"  (ngModelChange)="changeData($event)" [disabled]="isPreview"/>
        </div>
      </div>
    </div>
    <div class="progress-note-section" *ngIf="progressNoteStep == 2">
      <h4 class="w-100 text-center">Session Data Summary</h4>
      <div class="progress-note-section-content">
        <div *ngIf="isDataSummaryLoading" class="d-flex flex-column align-items-center justify-content-center py-4 gap-2">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem" aria-hidden="true"></i>
          <span>Calculating session data...</span>
        </div>
        <div *ngIf="!isDataSummaryLoading" class="w-100 progress-note-data-summary" [innerHTML]="progressNoteData.DataSummary" ></div>
      </div>
    </div>
    <div class="progress-note-section" *ngIf="progressNoteStep == 3">
      <h4 class="w-100 text-center">Select interventions were used to implement the protocol during the service</h4>
      <!--<div *ngFor="let i of bipInterventions">

  <div class="progress-note-section-content-item">
    <p-checkbox type="checkbox"
                [id]="i"
                class="progress-note-section-content-item-checkbox"
                name="bipInterventions"
                [value]="i"
                [(ngModel)]="sessionInterventions"></p-checkbox>
    <label [for]="i"
           class="ms-2 progress-note-section-content-item-label">{{i}}</label>
  </div>-->
      <div *ngFor="let i of interventions">
        <div class="progress-note-section-content-item">
          <p-checkbox type="checkbox"
                      [id]="i"
                      class="progress-note-section-content-item-checkbox"
                      name="interventions"
                      [value]="i"
                      [(ngModel)]="sessionInterventions" (ngModelChange)="changeData($event)" [disabled]="isPreview"></p-checkbox>
          <label [for]="i"
                 class="ms-2 progress-note-section-content-item-label">{{i}}</label>
        </div>
      </div>

      <div class="progress-note-section-content-item">

        <label for="others-intervention-at-session"
               class="me-2 progress-note-section-content-item-label">Other</label>
        <input type="text" id="others-intervention-at-session" class="form-control" [(ngModel)]="otherInterventionAtSession" (ngModelChange)="changeData($event)" [disabled]="isPreview" />
      </div>
    </div>
    <div class="progress-note-section" *ngIf="progressNoteStep == 4">
      <h4 class="w-100 text-center">Goals</h4>
      
      <div class="progress-note-section-content" *ngIf="linkedGoals?.length == 0">
        <p>No data on targets linked to goals</p>
      </div>
      <div class="progress-note-section-content mb-3" *ngFor="let goal of linkedGoals">
        <h6>{{goal}}</h6>
        <!--<div>Progress toward this goal:</div>
  <textarea class="form-control" [(ngModel)]="goalProgresses[goal?.ID??0]"  rows="15" (ngModelChange)="changeData($event)" [disabled]="isPreview"></textarea>-->
      </div>
    </div>
    <div class="progress-note-section" *ngIf="progressNoteStep == 5">
      <h4 class="w-100 text-center">Session Summary of Progress, Barriers, and Responses to Significant Others</h4>
      <div class="progress-note-section-content">
        <textarea class="form-control" [(ngModel)]="progressNoteData.Progress" rows="15" (ngModelChange)="changeData($event)" [disabled]="isPreview"></textarea>
      </div>
    </div>
    <div class="flex justify-content-center text-center gap-2 p-3 w-100">
      <p-button
        label="Back"
        class="me-3"
        severity="secondary"
        [class.hide]="progressNoteStep == 1"
        (onClick)="backProgressNote()"
      />
      <p-button
        label="Next"
        [class.hide]="progressNoteStep == 5"
        (onClick)="nextProgressNote()"
      />
      <p-button
        *ngIf="!isPreview"
        label="End Session"
        (onClick)="endSession()"
        [class.hide]="progressNoteStep != 5"
      />
    </div>
  </div>
